import { TOptions } from 'i18next';
import Message from './message';

const validator = {

  FILE_NAME_MAX_LENGTH: 50,
  FILE_NAME_BAN_SPECIAL_CHARS: '\'",./<>^@!',
  checkFileName(str: string) {
    const regex = new RegExp(`[${this.FILE_NAME_BAN_SPECIAL_CHARS}]`);
    if (str.length === 0) {
      return {
        err: Message.파일이름을입력하세요,
      };
    }
    if (str.length > this.FILE_NAME_MAX_LENGTH) {
      return {
        err: Message.파일이름은최대$1자까지입력가능합니다,
        args: { value: this.FILE_NAME_MAX_LENGTH } as TOptions,
      };
    }
    if (regex.test(str)) {
      return {
        err: Message.파일이름에특수문자$1를사용할수없습니다,
        args: { value: this.FILE_NAME_BAN_SPECIAL_CHARS } as TOptions,
      };
    }
    return { err: '' };
  },

  APP_FILE_DESCRIPTION_MAX_LENGTH: 200,
  checkAppDescription(str: string) {
    if (str.length > this.APP_FILE_DESCRIPTION_MAX_LENGTH) {
      return {
        err: Message.설명글은최대$1자까지입력가능합니다,
        args: { value: this.APP_FILE_DESCRIPTION_MAX_LENGTH } as TOptions,
      };
    }
    return { err: '' };
  },

  // EMAIL_REGEX: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  // 정규식 수정 -> .까지 나와야 통과되는걸로 교체
  EMAIL_REGEX: /^[a-zA-Z0-9+-_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
  checkEmail(str: string) {
    if (str.length === 0) {
      return Message.이메일을입력하세요;
    }
    if (!this.EMAIL_REGEX.test(str)) {
      return Message.올바른이메일이아닙니다;
    }
    return '';
  },

  PASSWORD_MAX_LENGTH: 32,
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_CONTAINS_LEAST_LOWERCASE: false,
  PASSWORD_CONTAINS_LEAST_UPPERCASE: false,
  PASSWORD_CONTAINS_ENGLISH: true,
  PASSWORD_CONTAINS_NUMBER: true,
  PASSWORD_CONTAINS_SPECIAL_CHAR: true,
  PASSWORD_SPECIAL_CHARLIST: '!@#$%^*',
  checkPassword(str: string) {
    if (str.length === 0) {
      return {
        err: Message.비밀번호를입력하세요,
      };
    }
    if (str.length < this.PASSWORD_MIN_LENGTH) {
      return {
        err: Message.비밀번호를$1자이상입력해주세요,
        args: { value: this.PASSWORD_MIN_LENGTH },
      };
    }
    if (str.length > this.PASSWORD_MAX_LENGTH) {
      return {
        err: Message.비밀번호를$1자이하로입력해주세요,
        args: { value: this.PASSWORD_MAX_LENGTH },
      };
    }

    let passwordRegex = '';
    passwordRegex += '^';
    if (this.PASSWORD_CONTAINS_LEAST_LOWERCASE) passwordRegex += '(?=.*[a-z])';
    if (this.PASSWORD_CONTAINS_LEAST_UPPERCASE) passwordRegex += '(?=.*[A-Z])';
    if (this.PASSWORD_CONTAINS_ENGLISH) passwordRegex += '(?=.*[a-zA-Z])';
    if (this.PASSWORD_CONTAINS_NUMBER) passwordRegex += '(?=.*[0-9])';
    if (this.PASSWORD_CONTAINS_SPECIAL_CHAR) passwordRegex += `(?=.*[${this.PASSWORD_SPECIAL_CHARLIST}])`;
    // eslint-disable-next-line max-len
    passwordRegex += `[a-zA-Z0-9${this.PASSWORD_SPECIAL_CHARLIST}]{${this.PASSWORD_MIN_LENGTH},${this.PASSWORD_MAX_LENGTH}}$`;

    if (!new RegExp(passwordRegex).test(str)) {
      const rules: string[] = [];
      if (this.PASSWORD_CONTAINS_ENGLISH) rules.push(Message.영어대소문자);
      if (this.PASSWORD_CONTAINS_NUMBER) rules.push(Message.숫자);
      if (this.PASSWORD_CONTAINS_SPECIAL_CHAR) rules.push(this.PASSWORD_SPECIAL_CHARLIST);
      return {
        err: Message.비밀번호는$1로입력해주세요,
        args: { valueKeys: rules },
      };
    }
    return { err: '' };
  },

  NICKNAME_MIN_LENGTH: 0,
  NICKNAME_MAX_LENGTH: 10,
  checkName(str: string) {
    if (str.length === 0) {
      return {
        err: Message.이름을입력해주세요,
      };
    }
    if (str.length < this.NICKNAME_MIN_LENGTH) {
      return {
        err: Message.이름은최소$1자이상입력해주세요,
        args: { value: this.NICKNAME_MIN_LENGTH },
      };
    }
    if (str.length > this.NICKNAME_MAX_LENGTH) {
      return {
        err: Message.이름은최대$1자이하까지입력가능합니다,
        args: { value: this.NICKNAME_MAX_LENGTH },
      };
    }
    return { err: '' };
  },
  BELONG_MIN_LENGTH: 0,
  BELONG_MAX_LENGTH: 30,
  checkBelong(str: string) {
    if (str.length === 0) {
      return {
        err: Message.소속정보를입력해주세요,
      };
    }
    if (str.length < this.BELONG_MIN_LENGTH) {
      return {
        err: Message.소속은최소$1자이상입력해주세요,
        args: { value: this.BELONG_MIN_LENGTH },
      };
    }
    if (str.length > this.BELONG_MAX_LENGTH) {
      return {
        err: Message.소속은최대$1자이하까지입력가능합니다,
        args: { value: this.BELONG_MAX_LENGTH },
      };
    }
    return { err: '' };
  },
  /** 핸드폰 번호 형식  */
  checkPhoneNumber(str: string) {
    if (str.length === 0) {
      return {
        err: Message.전화번호를입력해주세요,
      };
    }
    const phone = Number(str.split('-').join(''));

    if (Number.isNaN(phone)) {
      return {
        err: Message.숫자또는대시만입력가능합니다,
        // args: { value: phone },
      };
    }
    return { err: '' };
  },
};

export default validator;
